@if (isVisible) {
<div id="dx-page-loader-container" data-automation-id="page-loader-container" class="bl-top--0 dx-workflow-loader bl-position--fixed bl-width--100 bl-height--100">
  <div class="loader-root" [ngClass]="backgroundMode">
    <ng-container
      [ngTemplateOutlet]="options?.overlayMode === 'card' ? cardTemplate : otherTemplate"
      [ngTemplateOutletContext]="{ content: loaderTemplate }"
    >
    </ng-container>
  </div>
</div>
}

<ng-template #loaderTemplate>
  @switch(options.animationId) { @case ('documentscan') {
  <dx-check-app-animation id="dx-doc-animation-container" />
  } @case ('default') {
    <ea-orbit-loader id="dx-orbital-animation-container" [loading]="true"></ea-orbit-loader>
  } @case ('padded') {
    <div id="dx-empty-animation-block" class="fixed-animation-sized-block"></div>
  } @default {
    <!-- no loader -->
  } }
  <div class="bl-display--flex bl-flex-direction--column bl-align-items--center">
    @if (options.segments > 0) {
    <!-- Invisible bar for dots -->
    <div class="invisible-bar">
      <div class="bubbles">
        <div
          *ngFor="let segment of options.segments | numberToArray; let i = index"
          class="bubble"
          [class.active]="i === currentSegment && triggerBubbleAnimation"
          [class.complete]="i < currentSegment || isComplete"
        ></div>
      </div>
    </div>
    <!-- Visible progress bar -->
    <div class="progress-bar" [style.width.%]="progress"></div>
    <progress id="dx-page-loader-progress" class="loader-progress-bar" max="100" [value]="progress"></progress>
    }
  </div>
  <p id="dx-page-loader-message" data-automation-id="page-loader-message" [ngClass]="{ message: triggerTextAnimation }" class="bl-text-align--center bl-margin-top--24 bl-text-style--secondary-text-2">
    @if (message) {
    {{ message }}
    } @else { &nbsp; }
  </p>
</ng-template>

<ng-template #cardTemplate>
  <div class="bl-padding-top--24 bl-padding-bottom--40 bl-padding-x--16 bl-padding-x-sm--24">
    <div class="bl-max-width--layout bl-margin-x--auto">
      <div class="bl-max-width--tablet-width bl-margin-x--auto">
        <div class="dx-workflow-card bl-block-module bl-margin-x--auto">
          <div class="container bl-margin-x--auto bl-display--flex bl-flex-direction--column bl-align-items--center">
            <ng-container [ngTemplateOutlet]="loaderTemplate" />
          </div>
        </div>
      </div>
    </div>
  </div>
</ng-template>

<ng-template #otherTemplate>
  <div class="bl-padding-top--24 bl-padding-bottom--40 bl-padding-x--16 bl-padding-x-sm--24">
    <div class="bl-max-width--layout bl-margin-x--auto">
      <div class="bl-max-width--tablet-width bl-margin-x--auto">
        <ng-container [ngTemplateOutlet]="loaderTemplate" />
      </div>
    </div>
  </div>
</ng-template>
